import { apiClient } from '../lib/apiClient';
import { shareInFlightRequest } from '../lib/sharedApiRequest';
import type { WeeklyReportPublicSettingRow } from '../lib/weeklyReportPublicScopeDisplay';

const WR_PUBLIC_SETTING_PATH = '/get_wr_public_setting';
const WR_PUBLIC_SETTING_REQUEST_KEY = 'get-wr-public-setting:all:fresh';

/**
 * 週報分類の公開範囲を最新状態で取得する。
 *
 * 公開範囲は入力画面の表示・検索可否に直結するため、ブラウザや中継経路に
 * 過去の GET 応答が残っていても再利用されないようにする。
 */
export const fetchLatestWeeklyReportPublicSettings = async (): Promise<
  WeeklyReportPublicSettingRow[]
> => {
  const response = await shareInFlightRequest(
    WR_PUBLIC_SETTING_REQUEST_KEY,
    () =>
      apiClient.get<WeeklyReportPublicSettingRow[]>(WR_PUBLIC_SETTING_PATH, {
        headers: {
          Accept: 'application/json',
        },
        params: {
          _public_scope_refresh: Date.now(),
        },
      })
  );

  if (!Array.isArray(response.data)) {
    throw new Error('公開範囲設定の応答を確認できません。画面を再読み込みしてください。');
  }
  return response.data;
};
